module.exports = __webpack_public_path__ + "fonts/700-normal-greek-ext.9c8e86e.woff2";